export default __webpack_public_path__ + "static/media/home_tapistre.37a95603.jpg";